import api from "@/api/apiAlarm";
import { getTimeZone, convertTimeZone } from "@/utils/localeTime";

export default {
  namespaced: true,
  state() {
    return {
      // 이전에 선택한 알람 활성화 상태 및 알람음 조회
      smartAlarm: [],

      // 알람음 변경
      smartChk: false, // 알람 활성화 상태
      selectSmart: 1, // 알람음 id
      clickSmart: "기본음", // 기본음 or Sound N

      // Histories
      smartHist: [],
    };
  },
  mutations: {
    // 알람음 변경시 id 반영
    chooseSmartSound(state, value) {
      state.selectSmart = value;
    },
    // 알람음 변경시 기본음/Sound N 반영
    changeSmartSound(state, value) {
      state.clickSmart = value;
    },
    // 알람 활성화 상태 변경
    changeActiveSmart(state, payload) {
      state.smartChk = payload.state;
    },
  },
  actions: {
    // 이전에 선택한 알람음 조회 및 적용
    async getSmartAlarm(context) {
      try {
        const result = await api.getSmartSound();

        if (result.isSuccess) {
          let data = result.data;
          context.state.smartAlarm = data;
          context.commit("changeActiveSmart", { state: data.active });
          if (data.display.split(" ")[2] === undefined) {
            context.state.selectSmart = 1;
          } else {
            context.state.selectSmart = Number(data.display.split(" ")[2]) + 1;
          }
        }
      } catch (error) {
        // // console.log("getAlarmVolat ", error);
        return;
      }
    },

    // Histories
    async getHistSmart(context) {
      try {
        const result = await api.getSmartHistory();
        const regionCode = localStorage.getItem("regionCode");
        const timeZone = getTimeZone(regionCode);

        if (result.isSuccess) {
          let data = result.data;
          for (let i = 0; i < data.length; i++) {
            const localeDate = convertTimeZone(data[i].regDate, timeZone);

            // Format the date
            const year = localeDate.getFullYear();
            const month = String(localeDate.getMonth() + 1).padStart(2, "0");
            const day = String(localeDate.getDate()).padStart(2, "0");
            data[i].Date = `${year}.${month}.${day}`;

            // Format the time
            const hours = String(localeDate.getHours()).padStart(2, "0");
            const minutes = String(localeDate.getMinutes()).padStart(2, "0");
            data[i].Time = `${hours}:${minutes}`;
          }

          // Sorting logic
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return new Date(b.Date) - new Date(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });

          context.state.smartHist = data;
          // console.log('data', data);

        }
      } catch (error) {
        // // console.log("getHistVol ", error);
        return;
      }
    },
  },
};
